import { BaseState } from '@/store/base-state';
import { GlobalSearch, SearchFilters } from '../types';

export default class GobalSearchState extends BaseState {
  search_items: GlobalSearch.SearchItems[] = [];
  available_search_pages: GlobalSearch.SearchPages[] = [];
  search = '';
  search_loading = false;
  selected_item = 'all';

  filters: SearchFilters = {
    search: '',
    page: null,
  }
}
